import NotFound from "@/views/NotFound.vue";
import PortalSelectionPage from "@/views/PortalSelectionPage.vue";
import InitialSetupLanding from "@/views/InitialSetupLanding.vue";

import DirectComponentRoutes from "./DirectComponentRoutes";
import PublicRoutes from "./PublicRoutes";
import CustomerRoutes from "./CustomerRoutes";
import PartnerRoutes from "./PartnerRoutes";
import ServiceProviderRoutes from "./ServiceProviderRoutes";

export const legacyNotFoundPath = "*";
export const modernNotFoundPath = "/:pathMatch(.*)*";

export function createAppRoutes({ notFoundPath = legacyNotFoundPath } = {}) {
  return [
    {
      path: "/",
      name: "Home",
      component: PortalSelectionPage,
    },
    {
      path: "/about",
      name: "About",
      component: () => import(/* webpackChunkName: "about" */ "@/views/About.vue"),
    },
    {
      path: "/initial-setup",
      name: "InitialSetupLanding",
      component: InitialSetupLanding,
    },
    PublicRoutes,
    DirectComponentRoutes,
    CustomerRoutes,
    ...PartnerRoutes,
    ServiceProviderRoutes,
    { path: notFoundPath, component: NotFound },
  ];
}

export function getLegacyRouteTree() {
  return createAppRoutes({ notFoundPath: legacyNotFoundPath });
}
